/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { InputField, SelectField } from 'cx-ui-components';

export const PriorityField = ({ disabled }) => (
  <Fragment>
    <InputField
      name="minPriority"
      label="Min Priority"
      componentType="input"
      dataType="number"
      minValue="1"
      maxValue="1000"
      alignInptTextToRight
      disabled={disabled}
      integersOnlyAllowed
      data-automation="minPriorityInput"
    />
    <InputField
      name="maxPriority"
      label="Max Priority"
      componentType="input"
      dataType="number"
      minValue="1"
      maxValue="1000"
      alignInptTextToRight
      disabled={disabled}
      integersOnlyAllowed
      data-automation="maxPriorityInput"
    />
    <InputField
      name="priorityValue"
      label="Priority Value"
      componentType="input"
      dataType="number"
      minValue="1"
      maxValue="1000"
      alignInptTextToRight
      disabled={disabled}
      integersOnlyAllowed
      data-automation="priorityValueInput"
    />
    <InputField
      name="priorityRate"
      label="Priority Rate"
      componentType="input"
      dataType="number"
      minValue="1"
      alignInptTextToRight
      disabled={disabled}
      integersOnlyAllowed
      data-automation="priorityRateInput"
    />
    <SelectField
      name="priorityUnit"
      label="Priority Unit"
      options={[
        { value: 'seconds', label: 'Seconds' },
        { value: 'minutes', label: 'Minutes' },
        { value: 'hours', label: 'Hours' },
        { value: 'days', label: 'Days' },
      ]}
      data-automation="priorityUnitList"
      disabled={disabled}
    />
  </Fragment>
);

PriorityField.propTypes = {
  disabled: PropTypes.bool,
};
